// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* outer card container */
.card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 8px;
    padding: 40px 0px;
    min-height: 100%;
}

/* inner container */
.comp-cards__inner {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    align-content: flex-start;
    grid-gap: 24px;
    padding: 0px 24px;
    max-width: 100%;
}

.comp-cards__item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border-radius: 8px;
    overflow: hidden;
    opacity: 1;
    position: relative;
}

.card__media {
    flex: 0 0 auto;
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    /* Adjust this value for aspect ratio */
    border-radius: 8px 8px 0 0;
    overflow: hidden;
} 

.competition-prize {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card__body {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding: 40px 24px;
    background-color: var(--background-dark);
    opacity: 1;
    position: relative;
    /* adjust height for card body */
    /* height: 780px; */
    height: 580px;
}

.card__bottom {
    position: absolute;
    bottom: 0;
    left: 28px;
    right: 0;
    padding-bottom: 48px;
}

/* Card Media Queries */

@media (max-width: 280px) {
    .comp-cards__item {
        width: 280px;
        height: auto;
        margin: 0 auto;
    }

    .card__inner {
        padding-left: 0;
        padding-right: 0;
    }
}

@media (min-width: 500px) and (max-width: 752px) {
    .comp-cards__item {
        min-height: auto;
    }
}

@media (min-width: 539px) and (max-width: 541px) {
    .card__media {
        min-height: auto;
    }
}

@media (min-width: 768px) {
    .comp-cards__item {
        height: auto;
    }
}

@media (min-width: 770px) {
    .comp-cards__item {
        height: auto;
    }
}

@media (min-width: 768px) and (max-width: 800px) {
    .card__media {
        min-height: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/cards/CompCards.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,2DAA2D;IAC3D,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,oBAAoB;IACpB,uCAAuC;IACvC,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;IAClB,wCAAwC;IACxC,UAAU;IACV,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,oBAAoB;AACxB;;AAEA,uBAAuB;;AAEvB;IACI;QACI,YAAY;QACZ,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* outer card container */\n.card-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 40px 0px;\n    min-height: 100%;\n}\n\n/* inner container */\n.comp-cards__inner {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    align-content: flex-start;\n    grid-gap: 24px;\n    padding: 0px 24px;\n    max-width: 100%;\n}\n\n.comp-cards__item {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    border-radius: 8px;\n    overflow: hidden;\n    opacity: 1;\n    position: relative;\n}\n\n.card__media {\n    flex: 0 0 auto;\n    position: relative;\n    width: 100%;\n    height: 0;\n    padding-bottom: 100%;\n    /* Adjust this value for aspect ratio */\n    border-radius: 8px 8px 0 0;\n    overflow: hidden;\n} \n\n.competition-prize {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.card__body {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding: 40px 24px;\n    background-color: var(--background-dark);\n    opacity: 1;\n    position: relative;\n    /* adjust height for card body */\n    /* height: 780px; */\n    height: 580px;\n}\n\n.card__bottom {\n    position: absolute;\n    bottom: 0;\n    left: 28px;\n    right: 0;\n    padding-bottom: 48px;\n}\n\n/* Card Media Queries */\n\n@media (max-width: 280px) {\n    .comp-cards__item {\n        width: 280px;\n        height: auto;\n        margin: 0 auto;\n    }\n\n    .card__inner {\n        padding-left: 0;\n        padding-right: 0;\n    }\n}\n\n@media (min-width: 500px) and (max-width: 752px) {\n    .comp-cards__item {\n        min-height: auto;\n    }\n}\n\n@media (min-width: 539px) and (max-width: 541px) {\n    .card__media {\n        min-height: auto;\n    }\n}\n\n@media (min-width: 768px) {\n    .comp-cards__item {\n        height: auto;\n    }\n}\n\n@media (min-width: 770px) {\n    .comp-cards__item {\n        height: auto;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 800px) {\n    .card__media {\n        min-height: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
